module.exports = __webpack_public_path__ + "static/media/divider.c6e8c036.png";